<template>
  <v-dialog
      v-model="dialog"
      fullscreen
      persistent
  >
    <v-card>
      <v-card-title>
        Sipariş Düzenle
        <v-spacer></v-spacer>
        <v-btn @click="dialog = false" color="danger darken-1" style="color: white;">
          KAPAT
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-expansion-panels v-model="panels" dense class="mt-5" flat tile hover multiple>
          <v-expansion-panel
          >
            <v-expansion-panel-header class="bg-light">
              <span><v-icon left>mdi-information-variant</v-icon>Cari Bilgileri</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="container-xxl-fluid">
                <div class="row">
                  <div class="col-lg-4">
                    <v-text-field
                        :value="orderInfo.currentCode"
                        label="Cari Kodu"
                        placeholder=" "
                        readonly
                        hide-details
                        filled
                        flat
                        solo
                        dense
                    ></v-text-field>
                  </div>
                  <div class="col-lg-4">
                    <v-text-field
                        :value="orderInfo.currentName"
                        label="Cari Ünvanı"
                        placeholder=" "
                        hide-details
                        readonly
                        filled
                        solo
                        dense
                        flat
                    ></v-text-field>

                  </div>
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel
          >
            <v-expansion-panel-header class="bg-light">
              <span><v-icon left>mdi-plus</v-icon>Stok Ekle</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="mx-auto my-4">
                <v-text-field
                    v-model="searchText"
                    class="mt-5 pt-3"
                    outlined
                    rounded
                    dense
                    placeholder="Arama Yapın..."
                    clearable
                    color="secondary"
                    hide-details
                    append-icon="mdi-magnify"
                    @click:append="searchListWithText()"
                    @keydown.enter="searchListWithText()"
                ></v-text-field>
              </div>
              <b-table
                  caption-top
                  :caption="stockList.length > 0 && stockList ? 'Toplam ' + stockList.length + ' kayıt bulundu'  : ''"
                  :items="stockList"
                  :fields="stockListHeaders.filter(item => item.visible)"
                  hover
                  head-row-variant="info"
                  table-variant="white"
                  responsive
                  per-page="10"
                  :busy="stockListLoading"
                  show-empty
              >
                <template #empty="scope">
                  <h6 class="text-center my-5">
                    {{ scope.loading ? "Lütfen Bekleyin" : noStockMessage }}
                  </h6>
                </template>
                <template #cell(code)="data">

                  {{ data.item.code }}

                </template>
                <template #cell(name)="data">

                  {{ data.item.name }}

                </template>
                <template #cell(balance)="data">
                  <span v-if="user.RoleGroupId !== '3'">{{ numberConverter(data.item.balance) }}</span>
                  <span v-if="user.RoleGroupId === '3' && data.item.stockStatus === 0">{{
                      data.item.numericStockBalance
                    }}</span>
                  <span v-if="user.RoleGroupId === '3' && data.item.stockStatus === 1"
                        style="height: 15px; width: 15px; background-color: #04AA6B; border-radius: 50%; display: inline-block;"></span>
                  <span v-if="user.RoleGroupId === '3' && data.item.stockStatus === 2"
                        style="height: 15px; width: 15px; background-color: #DD1E34; border-radius: 50%; display: inline-block;"></span>
                </template>
                <template v-if="!user?.userInfo.priceIntervention" #cell(vatExcludedUnitPrice)="data">
                  <span>{{
                      numberConverter(data.item.vatExcludedUnitPrice) + fetchCurrencyLabel(data.item.currencyType)
                    }}</span>
                </template>
                <template v-else #cell(vatExcludedUnitPrice)="data">
                  <div class="d-flex align-items-center">
                    <input
                        type="text"
                        v-model="data.item.vatExcludedUnitPrice"
                        :key="data.item.code"
                        :min="0.01"
                        step="0.01"
                        inputmode="numeric"
                        pattern="[0-9]*[.,]?[0-9]+"
                        style="width: 60px; height: 32px; margin-right: 5px"
                        class="form-control form-control-sm text-right"
                    />
                    <span>{{ fetchCurrencyLabel(data.item.currencyType) }}</span>
                  </div>
                </template>
                <template #cell(discountUnitPrice)="data">
                  <span>{{
                      numberConverter(data.item.discountUnitPrice) + fetchCurrencyLabel(data.item.currencyType)
                    }}</span>
                </template>
                <template #cell(discount1)="data">
                  <input
                      v-if="user.RoleGroupId === '1'"
                      type="number"
                      v-model="data.item.discount1"
                      :key="data.item.code"
                      :min="1"
                      style="width: 60px; height: 32px"
                      class="form-control form-control-sm text-right"
                  />
                  <span v-else>{{ data.item.discount1 }}</span>
                </template>
                <template #cell(discount2)="data">
                  <input
                      v-if="user.RoleGroupId === '1'"
                      type="number"
                      v-model="data.item.discount2"
                      :key="data.item.code"
                      :min="1"
                      class="form-control form-control-sm text-right"
                      style="width: 60px; height: 32px"
                  />
                  <span v-else>{{ data.item.discount1 }}</span>
                </template>
                <template #cell(amount)="data">
                  <div class="d-flex">
                    <input
                        v-model="data.item.stockAmount"
                        type="number"
                        :min="1"
                        class="form-control form-control-sm text-right"
                        style="width: 60px; height: 32px"
                        @keydown.enter="e => cartStockChange(data.item, data.item.stockAmount, data.item.discount1, data.item.discount2)"
                        v-show="
              cartList.filter(e => e.stockCode === data.item.code).length < 1
            "
                    />
                    <input
                        v-if="cartList.filter(e => e.stockCode === data.item.code).length > 0"
                        type="number"
                        :value="cartList.find(e => e.stockCode == data.item.code).quantity"
                        :min="1"
                        class="form-control form-control-sm text-right"
                        style="width: 60px; height: 32px"
                        @keydown.enter="e => cartStockChange(data.item, e.target.value, data.item.discount1, data.item.discount2)"
                        @change="
              e =>
                (cartList.find(e => e.stockCode == data.item.code).quantity =
                  e.target.value)
            "
                    />
                  </div>
                </template>
                <template #cell(cartProcess)="data">
                  <v-btn
                      small
                      v-bind="attrs"
                      v-on="on"
                      color="primary"
                      @click="cartStockChange(data.item, data.item.stockAmount, data.item.discount1, data.item.discount2)"
                      v-show="
                  cartList.filter(e => e.stockCode === data.item.code).length <
                    1
                "
                  >
                    Sepete Ekle
                  </v-btn>

                  <div
                      class="d-flex justify-content-center"
                      v-if="cartList.filter(e => e.stockCode === data.item.code).length > 0"
                  >
                    <v-tooltip
                        bottom
                        v-if="
              cartList.filter(e => e.stockCode === data.item.code).length > 0
            "
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-bind="attrs"
                            v-on="on"
                            icon
                            color="success"
                            @click="cartStockChange(data.item, data.item.stockAmount,data.item.discount1, data.item.discount2)"
                        >
                          <v-icon small>mdi-basket-plus</v-icon>
                        </v-btn>
                      </template>
                      <span>Miktarı Değiştir</span>
                    </v-tooltip>
                    <v-tooltip
                        bottom
                        v-if="
              cartList.filter(e => e.stockCode === data.item.code).length > 0
            "
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-bind="attrs"
                            v-on="on"
                            icon
                            color="danger"
                            @click="cartStockRemove(data.item)"
                        >
                          <v-icon small>mdi-close</v-icon>
                        </v-btn>
                      </template>
                      <span>Sepetten Çıkar</span>
                    </v-tooltip>
                  </div>
                </template>
                <template #table-busy>
                  <div class="text-center">
                    <b-spinner
                        variant="primary"
                        size="lg"
                        label="Text Centered"
                    ></b-spinner>
                  </div>
                </template>
              </b-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel
          >
            <v-expansion-panel-header class="bg-light">
              <span><v-icon left>mdi-cart</v-icon>Sepet Bilgileri</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <table class="table align-middle mb-0 table-nowrap mt-4">
                <thead class="table-light">
                <tr class="table-info">
                  <th>Sıra</th>
                  <th>Stok Bilgileri</th>
                  <th v-if="erpSettings.CartShowBalance">Bakiye</th>
                  <th class="text-center">Adet</th>
                  <th class="text-center">Birim Fiyat</th>
                  <th class="text-center" v-if="erpSettings.netsisCurrencySale">Dövizli Birim Fiyat</th>
                  <th class="text-center">İskonto 1</th>
                  <th class="text-center">İskonto 2</th>
                  <th class="text-center">KDV</th>
                  <th class="text-center">Tutar</th>
                  <th class="text-center" v-if="erpSettings.netsisCurrencySale">Dövizli Tutar</th>
                  <th class="text-center">Sil</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,i) in orderInfo.orderDetails" :key="item.stockCode">
                  <td>
                    {{ i + 1 }}
                  </td>
                  <td>
                    <h5 class="font-size-14 text-truncate">
                      <router-link
                          :to="'/product-detail/' + item.stockCode"
                          target='_blank'
                          class="text-dark"
                      >{{ item.stockName }}
                      </router-link
                      >
                    </h5>
                    <p class="mb-0">
                      Stok Kodu :
                      <span class="fw-medium">{{ item.stockCode }}</span>
                    </p>
                  </td>
                  <td v-if="erpSettings.CartShowBalance">{{ item.stockBalance }}</td>
                  <td class="text-center">
                    <div class="d-flex justify-content-center">
                      <input
                          type="number"
                          :value="item.quantity"
                          :min="1"
                          class="form-control"
                          style="width: 80px"
                          @keydown.enter="
                      (e) =>
                        cartStockChange(item, parseInt(e.target.value), item.discount1, item.discount2)
                    "
                          @change="(e) => cartStockChange(item, parseInt(e.target.value), item.discount1, item.discount2)"
                      />
                    </div>
                  </td>

                  <td class="text-center">
                    <h5 v-if="item.discount1 || item.discount2" class="font-size-14 text-truncate">
                      {{ numberConverter(item.unitPrice * (100 - item.discount1 + item.discount2) / 100) }}
                    </h5>
                    <del v-if="item.discount1 || item.discount2">{{ numberConverter(item.unitPrice) }}</del>
                    <span v-if="!item.discount1 && !item.discount2"> {{ numberConverter(item.unitPrice) }} </span>
                  </td>
                  <td v-if="erpSettings.netsisCurrencySale" class="text-center">
                    <h5 v-if="item.discount1 || item.discount2" class="font-size-14 text-truncate">
                      {{
                        numberConverter(item.currencyUnitPrice * (100 - item.discount1 + item.discount2) / 100) + fetchCurrencyLabel(item.currencyType)
                      }}
                    </h5>
                    <del v-if="item.discount1 || item.discount2">
                      {{ numberConverter(item.currencyUnitPrice) + fetchCurrencyLabel(item.currencyType) }}
                    </del>
                    <span v-if="!item.discount1 && !item.discount2"> {{
                        numberConverter(item.currencyUnitPrice) + fetchCurrencyLabel(item.currencyType)
                      }} </span>

                  </td>

                  <td>
                    <div class="text-center" v-if="user.RoleGroupId === 3 || user.RoleGroupId === '3'">
                      {{ '%' + item.discount1 }}
                    </div>
                    <div v-else class="d-flex justify-content-center">
                      <input
                          type="number"
                          :value="item.discount1"
                          :min="1"
                          class="form-control"
                          style="width: 80px"
                          @keydown.enter="
                      (e) =>
                        cartStockChange(item, item.quantity, parseInt(e.target.value), item.discount2)
                    "
                          @change="(e) => cartStockChange(item, item.quantity,parseInt(e.target.value), item.discount2)"
                      />
                    </div>
                  </td>
                  <td>
                    <div class="text-center" v-if="user.RoleGroupId === 3 || user.RoleGroupId === '3'">
                      {{ '%' + item.discount2 }}
                    </div>
                    <div v-else class="d-flex justify-content-center">
                      <input
                          type="number"
                          :value="item.discount2"
                          :min="1"
                          class="form-control"
                          style="width: 80px"
                          @keydown.enter="
                      (e) =>
                        cartStockChange(item, item.quantity, item.discount1, parseInt(e.target.value))
                    "
                          @change="(e) => cartStockChange(item, item.quantity, item.discount1, parseInt(e.target.value))"
                      />
                    </div>
                  </td>
                  <td class="text-center">{{ '%' + item.vat }}</td>
                  <td class="text-center">
                    <h5 v-if="item.discount1 || item.discount2" class="font-size-14 text-truncate">
                      {{ numberConverter(item.amount * (100 - item.discount1 + item.discount2) / 100) }}
                    </h5>
                    <del v-if="item.discount1 || item.discount2">{{ numberConverter(item.amount) }}</del>
                    <span v-if="!item.discount1 && !item.discount2"> {{ numberConverter(item.amount) }} </span>

                  </td>
                  <td v-if="erpSettings.netsisCurrencySale" class="text-center">
                    <h5 v-if="item.discount1 || item.discount2" class="font-size-14 text-truncate">
                      {{
                        numberConverter(item.currencyAmount * (100 - item.discount1 + item.discount2) / 100) + fetchCurrencyLabel(item.currencyType)
                      }}
                    </h5>
                    <del v-if="item.discount1 || item.discount2" class="">
                      {{ numberConverter(item.currencyAmount) + fetchCurrencyLabel(item.currencyType) }}
                    </del>
                    <span v-if="!item.discount1 && !item.discount2"> {{
                        numberConverter(item.currencyAmount) + fetchCurrencyLabel(item.currencyType)
                      }} </span>

                  </td>
                  <td class="text-center">
                    <v-btn
                        style="background-color: rgb(244, 106, 106)"
                        small
                        href="javascript:void(0);"
                        class="action-icon text-light"
                        @click="cartStockRemove(item)"

                    >
                      <i class="mdi mdi-trash-can font-size-14"></i>
                    </v-btn>
                  </td>
                </tr>
                </tbody>
              </table>


            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel
          >
            <v-expansion-panel-header class="bg-light">
              <span><v-icon left>mdi-book-information-variant</v-icon>Sipariş Bilgileri</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="container-xxl-fluid">
                <div class="row">
                  <div class="col-lg-4">
                    <span class="ml-3 fw-bold">Sipariş Numarası</span>
                    <v-text-field
                        v-model="orderInfo.orderNumber"
                        label="Sipariş No"
                        readonly
                        filled
                        solo
                        dense
                        flat
                    ></v-text-field>
                  </div>
                  <div class="col-lg-4">
                    <span class="ml-3 fw-bold">Proje Kodu</span>

                    <v-text-field
                        v-model="orderInfo.projectCode"
                        label="Sipariş No"
                        readonly
                        filled
                        solo
                        dense
                        flat
                    ></v-text-field>
                  </div>
                  <div class="col-lg-4">
                    <span class="ml-3 fw-bold">Açıklama</span>

                    <v-text-field
                        v-model="orderInfo.description"
                        label="Açıklama"
                        filled
                        solo
                        dense
                    ></v-text-field>
                  </div>
                  <div class="col-lg-12">
                    <v-textarea
                        v-model="orderInfo.deliveryAddress"
                        label="Sevk Adresi"
                        filled
                        solo
                        dense
                    ></v-textarea>
                  </div>
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel
          >
            <v-expansion-panel-header class="bg-light">
              <span><v-icon left>mdi-check</v-icon>Tutar Özeti</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="container-xxl-fluid">
                <div class="row flex-row-reverse">
                  <div class="col-lg-4">
                    <div class="table-responsive mt-4 ">
                      <table class="table mb-0">
                        <tbody>
                        <tr>
                          <td>Brüt Tutar</td>
                          <td>{{ numberConverter(cartTotalInfo.grossTotal) }}</td>
                        </tr>
                        <tr>
                          <td>İskonto</td>
                          <td>{{ numberConverter(cartTotalInfo.discountTotal) }}</td>
                        </tr>
                        <tr>
                          <td>Ara Toplam</td>
                          <td>{{ numberConverter(cartTotalInfo.subTotal) }}</td>
                        </tr>
                        <tr>
                          <td>KDV</td>
                          <td>{{ numberConverter(cartTotalInfo.kdvTotal) }}</td>
                        </tr>
                        <tr>
                          <th>Son Tutar :</th>
                          <th>{{ numberConverter(cartTotalInfo.total) }}</th>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <div class="d-flex">
          <v-spacer></v-spacer>
          <v-btn color="success darken-3" @click="closeDialog()">Kaydet</v-btn>
        </div>

      </v-card-text>

    </v-card>
  </v-dialog>
</template>

<script>

import {mapActions, mapState, mapMutations, mapGetters} from "vuex";
import {formattedDate} from "@/momentHelper";
import {numberConverter} from "../../../../../helpers";


export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    orderNumber: {
      type: String,
      default: null
    },
    orderId: {
      type: Number,
      default: null
    }
  },
  components: {},
  computed: {
    ...mapState("cart", ["cartList", "current", "cartListMetaData"]),
    ...mapState("stock", [
      "stockList",
      "stockListLoading",
      "noStockMessage",
    ]),
    ...mapState("auth", ["user"]),
    ...mapState("settings", ["erpSettings"]),
    ...mapGetters("settings", ["getCurrencyLabels"]),
    currencyLabels: {
      get() {
        return this.getCurrencyLabels;
      },
    },
  },
  mounted() {

  },
  data() {
    return {
      panels: [0, 2, 3, 4],
      dialog: false,
      orderInfo: {
        orderDetails: []
      },
      on: {},
      attrs: {},
      orderInfoTableHeaders: [
        {
          key: 'stockName',
          label: 'Stok Adı',
          sortable: false,
        },
        {
          key: 'stockCode',
          label: 'Stok Kodu',
          sortable: false,
        },
        {
          key: 'description',
          label: 'Not',
          sortable: false,
        },
        {
          key: 'quantity',
          label: 'Miktar',
          sortable: false,
        },
        {
          key: 'unitPrice',
          label: 'Birim Fiyat',
          sortable: false,
        },
        {
          key: 'discount1',
          label: 'İskonto 1',
          sortable: false,
        },
        {
          key: 'discount2',
          label: 'İskonto 2',
          sortable: false,
        },
        {
          key: 'amount',
          label: 'Tutar',
          sortable: false,
        },
      ],
      cartTotalInfo: {
        grossTotal: 0,
        discountTotal: 0,
        subTotal: 0,
        kdvTotal: 0,
        total: 0
      },
      searchText: null,
      stockListHeaders: [
        {
          key: 'code',
          label: 'Stok Kodu',
          sortable: false,
          visible: true,
          class: 'text-center align-middle text-nowrap',

        },
        {
          key: 'name',
          label: 'Stok Adı',
          sortable: false,
          visible: true,
          class: 'text-left align-middle',

        },
        {
          key: 'balance',
          label: 'Bakiye',
          sortable: false,
          visible: true,
          class: 'text-center align-middle text-nowrap',

        },
        {
          key: 'vatExcludedUnitPrice',
          label: 'Liste Fiyatı',
          sortable: false,
          visible: true,
          class: 'text-center align-middle text-nowrap',

        },
        {
          key: 'discountUnitPrice',
          label: 'İndirimli Fiyat',
          sortable: false,
          visible: true,
          class: 'text-center align-middle text-nowrap',

        },
        {
          key: 'discount1',
          label: 'İskonto 1',
          sortable: false,
          visible: true,
          class: 'text-center align-middle text-nowrap',

        },
        {
          key: 'discount2',
          label: 'İskonto 2',
          sortable: false,
          visible: true,
          class: 'text-center align-middle text-nowrap',

        },
        {
          key: 'amount',
          label: 'Miktar',
          sortable: false,
          visible: true,
          stickyColumn: false,
          class: 'text-center align-middle text-nowrap',
        },
        {
          key: 'cartProcess',
          label: 'Sepete Ekle',
          sortable: false,
          class: 'text-center align-middle',
          visible: true,
          stickyColumn: false,
        },
      ]
    }

  },
  methods: {
    numberConverter,
    formattedDate,
    ...mapActions("order", ["fetchSingleOrder", "updateOrder"]),
    ...mapActions("stock", ["fetchStockList"]),
    ...mapMutations("stock", ["setStockList"]),
    fetchCurrencyLabel(currencyType) {
      if (currencyType == null) return " ₺";
      console.log(currencyType);
      for (const item of this.currencyLabels) {
        if (item.id === currencyType) {
          return item.label;
        }
      }
      return '';
    },
    async _fetchSingleOrder() {
      this.orderInfo = await this.fetchSingleOrder({
        params: {},
        body: {},
        urlSegments: [this.orderId]
      })
      this.initCartTotalInfo();
    },
    initCartTotalInfo() {
      this.cartTotalInfo = {
        grossTotal: 0,
        discountTotal: 0,
        subTotal: 0,
        kdvTotal: 0,
        total: 0
      }
      if (this.orderInfo && this.orderInfo.orderDetails.length > 0) {
        for (let i = 0; i < this.orderInfo.orderDetails.length; i++) {
          this.cartTotalInfo.grossTotal += this.orderInfo.orderDetails[i].amount;
          this.cartTotalInfo.kdvTotal += this.orderInfo.orderDetails[i].vatAmount;
          this.cartTotalInfo.discountTotal = this.orderInfo.orderDetails[i].discountAmount1 + this.orderInfo.orderDetails[i].discountAmount2 + this.orderInfo.orderDetails[i].paymentDiscountAmount
        }


        this.cartTotalInfo.subTotal = this.cartTotalInfo.grossTotal - this.cartTotalInfo.discountTotal;
        this.cartTotalInfo.total = this.cartTotalInfo.kdvTotal + this.cartTotalInfo.subTotal;
      }
    },
    async cartStockChange(product, quantity = 1, discount1 = 0, discount2 = 0) {
      if (this.user.userInfo.priceIntervention) {
        let originalPrice = null;
        if (typeof (product.vatExcludedUnitPrice) === "string") {
          originalPrice = product.vatExcludedUnitPrice.replace('.', '').replace(',', '.');
          originalPrice = parseFloat(originalPrice);
        } else {
          originalPrice = product.vatExcludedUnitPrice
        }
        let stock = this.orderInfo.orderDetails.find(item => (item.stockCode === product.code || item.stockCode === product.stockCode));
        if (stock) {
          stock.quantity = quantity;
          stock.discount1 = discount1;
          stock.discount2 = discount2;
          await this._updateOrder();
        } else {
          stock = product;
          stock.Unit = 1;
          stock.quantity = quantity;
          stock.discount1 = discount1;
          stock.discount2 = discount2;
          stock.stockName = product.name;
          stock.stockCode = product.code;
          stock.unitPrice = originalPrice;
          this.orderInfo.orderDetails.push(stock);
          await this._updateOrder();
        }
      } else {
        let stock = this.orderInfo.orderDetails.find(item => (item.stockCode === product.code || item.stockCode === product.stockCode));

        if (stock) {
          stock.quantity = quantity;
          stock.discount1 = discount1;
          stock.discount2 = discount2;
          await this._updateOrder();
        } else {
          stock = product;
          stock.Unit = 1;
          stock.quantity = quantity;
          stock.discount1 = discount1;
          stock.discount2 = discount2;
          stock.stockName = product.name;
          stock.stockCode = product.code;
          this.orderInfo.orderDetails.push(stock);
          await this._updateOrder();
        }
      }
      this.initCartTotalInfo();
    },
    async cartStockRemove(product) {
      let stock = this.orderInfo.orderDetails.find(item => (item.stockCode === product.code || item.stockCode === product.stockCode));
      if (!stock) {
        return;
      } else {
        let indexOfStock = this.orderInfo.orderDetails.indexOf(stock);
        if (indexOfStock > -1) { // only splice array when item is found
          this.orderInfo.orderDetails.splice(indexOfStock, 1); // 2nd parameter means remove one item only
        }
        await this._updateOrder()
      }

      this.initCartTotalInfo();
    },
    async _updateOrder() {
      await this.updateOrder({
        params: {
          userId: this.user.UserId,
        },
        body: {
          Order: this.orderInfo,
          OrderDetails: this.orderInfo.orderDetails
        }
      });
      await this._fetchSingleOrder()
    },
    async closeDialog() {
      await this.updateOrder({
        params: {
          userId: this.user.UserId,
        },
        body: {
          Order: this.orderInfo,
          OrderDetails: this.orderInfo.orderDetails
        }
      });
      await this._fetchSingleOrder()
      this.dialog = false;
    },

    async searchListWithText() {
      await this.fetchStockList({
        params: {
          pageNumber: 1,
          pageSize: 50,
          userId: this.user.UserId,
        },
        body: {
          stock: this.searchText,
          GenericCategories: null
        },
        loading: false
      });
    }
  },
  watch: {
    "dialog": function (newVal) {
      this.$emit("dialogChange", newVal)
      if (newVal) {
        this._fetchSingleOrder()

        this.setStockList([]);
      } else {
        this.cartTotalInfo = {
          grossTotal: 0,
          discountTotal: 0,
          subTotal: 0,
          kdvTotal: 0,
          total: 0
        }
      }

    },
    "showDialog": function (newVal) {
      if (!newVal) this.$parent._fetchB2BOrders();
      this.dialog = newVal
    }

  }
}
</script>